// extracted by mini-css-extract-plugin
export default {"indent":"Terms_indent__YSuDT","container":"Terms_container__2+tAF"};